export const BrandingPage = () => {
  return <div>BrandingPage</div>;
};
